import Image from 'next/image'
import Link from 'next/link'

export default function ReadyToStart() {
    return (
        <section className='relative h-[578px] md:h-[578] overflow-hidden rounded-b-3xl bg-white'>
            <Image
                src="/Integra-ai/shapes.png"
                alt="Background Shape"
                width={1368}
                height={869}
                className="absolute left-1/2 -bottom-[586px] -translate-x-1/2 max-w-[390%] md:max-w-none"
                priority
            />

            {/* Content Box */}
            <div className='absolute left-1/2 top-[346px] w-[90%] max-w-[508px] -translate-x-1/2'>
                {/* Heading */}
                <h2 className='font-inter text-center text-[32px] font-bold leading-[135%] text-[#333333]'>
                    Ready to Start?
                </h2>

                {/* Description */}
                <p className='font-inter mt-3 text-center text-sm font-normal leading-normal text-[#333333]'>
                    See how Integra AI can help you gain control, privacy and flexibility over your
                    AI ecosystem. Request a live demo to see it in action.
                </p>

                {/* Button */}
                <div className='mt-8 flex justify-center'>
                    <Link
                        href='/contact?ref=integra-ai-ready&utm_source=website&utm_medium=cta&utm_campaign=integra_ai&utm_content=integra_ai__ready__request_demo'
                        className='rounded-full border border-blue-700 bg-blue-700 px-5 py-2 text-sm text-white transition hover:bg-blue-500 sm:px-6 sm:text-base'>
                        Request Demo
                    </Link>
                </div>
            </div>
        </section>
    )
}
